export enum EPaymentMethod {
  CARD = 'credit-card',
  INVOICE = 'invoice',
}
